import React from 'react';
import qrCode from '../assets/donate.jpg'; // Updated to use your donate.jpg file

const Donate = () => {
  return (
    <div className="relative min-h-screen bg-[#EBDCCD] py-12 px-4 flex flex-col items-center justify-center font-sans overflow-hidden">

      {/* ---------------- BACKGROUND ARTWORK ---------------- */}

      {/* 1. Base Gradient Layer */}
      <div className="absolute inset-0 bg-gradient-to-tr from-[#EBDCCD] via-[#f2e4d5] to-[#EBDCCD]" />

      {/* 2. Bold, Glowing Pulsing Orbs */}
      <div className="absolute -top-20 -left-20 w-[600px] h-[600px] bg-gradient-to-br from-amber-400/50 via-orange-300/40 to-transparent rounded-full blur-[90px] pointer-events-none animate-pulse" />
      <div className="absolute -bottom-20 -right-20 w-[600px] h-[600px] bg-gradient-to-tl from-[#2C1A14]/30 via-amber-800/25 to-transparent rounded-full blur-[90px] pointer-events-none animate-pulse" style={{ animationDuration: '6s' }} />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-amber-200/40 rounded-full blur-[110px] pointer-events-none" />

      {/* 3. Grid Texture */}
      <div
        className="absolute inset-0 opacity-[0.12] pointer-events-none"
        style={{
          backgroundImage: `
            linear-gradient(to right, #2C1A14 1.5px, transparent 1.5px),
            linear-gradient(to bottom, #2C1A14 1.5px, transparent 1.5px)
          `,
          backgroundSize: '36px 36px'
        }}
      />

      {/* 4. Floating Sparkles & Badges */}
      <div className="absolute top-10 left-[8%] text-[#2C1A14]/40 text-4xl font-serif pointer-events-none select-none drop-shadow">✦</div>
      <div className="absolute top-24 right-[10%] text-[#2C1A14]/35 text-3xl font-serif pointer-events-none select-none drop-shadow">✧</div>
      <div className="absolute bottom-20 left-[12%] text-[#2C1A14]/35 text-3xl font-serif pointer-events-none select-none drop-shadow">✧</div>
      <div className="absolute bottom-8 right-[6%] text-[#2C1A14]/40 text-5xl font-serif pointer-events-none select-none drop-shadow">✦</div>

      {/* 5. Vignette Shadow */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_40%,rgba(44,26,20,0.15)_100%)] pointer-events-none" />

      {/* ---------------- MAIN CONTAINER ---------------- */}
      <div className="relative z-10 w-full max-w-md flex flex-col items-center">

        {/* Floating Bismillah Header */}
        <div className="inline-flex items-center gap-3 px-8 py-2.5 rounded-full bg-[#2C1A14]/10 border-2 border-[#2C1A14]/20 backdrop-blur-md mb-6 shadow-md">
          <p className="text-xl md:text-3xl font-serif font-bold text-[#3e2723] text-center italic tracking-wide">
            "Bismillah"
          </p>
        </div>

        {/* Donation Card Container */}
        <div className="w-full bg-[#FFFBF7]/95 backdrop-blur-xl rounded-3xl shadow-2xl border-2 border-[#2C1A14] p-8 text-center relative">

          <h2 className="text-3xl font-serif font-bold text-[#3e2723] mb-8">Support MBA Trust</h2>

          {/* GOOGLE PAY QR SECTION */}
          <div className="flex flex-col items-center">
            <label className="block text-[10px] font-bold text-stone-400 uppercase tracking-widest mb-4">Scan to Pay with Google Pay</label>
            <div className="bg-white p-4 rounded-2xl border-2 border-stone-100 shadow-inner">
              <img
                src={qrCode}
                alt="Google Pay QR Code"
                className="w-48 h-48 object-contain"
              />
            </div>
          </div>

          <p className="mt-8 text-[10px] text-stone-400 uppercase tracking-widest font-bold">
            Secure Payment Portal
          </p>
        </div>
      </div>
    </div>
  );
};

export default Donate;